import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=56f31e0c&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=56f31e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f31e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f31e0c')) {
      api.createRecord('56f31e0c', component.options)
    } else {
      api.reload('56f31e0c', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=56f31e0c&scoped=true&", function () {
      api.rerender('56f31e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9cxPCNEdpbi/JS/comp/DateRange.vue"
export default component.exports